"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/ValueAddedSolutions/assembly/specialist-industries";

const INDUSTRIES = [
	{ keyPrefix: "industriesCard1", image: `${IMAGE_BASE}/aerospace.webp`, href: "/industry/aerospace" },
	{ keyPrefix: "industriesCard2", image: `${IMAGE_BASE}/automotive.webp`, href: "/industry/automotive" },
	{ keyPrefix: "industriesCard3", image: `${IMAGE_BASE}/automation.webp`, href: "/industry/industry-equipment" },
	{ keyPrefix: "industriesCard4", image: `${IMAGE_BASE}/medical-devices.webp`, href: "/industry/medical-device" },
	{ keyPrefix: "industriesCard5", image: `${IMAGE_BASE}/robotics.webp`, href: "/industry/robotics-automation" },
	{ keyPrefix: "industriesCard6", image: `${IMAGE_BASE}/consumer-products.webp`, href: "/industry/consumer-goods" },
] as const;

export default function AssemblyIndustries() {
	const t = useTranslations("new-assembly");

	return (
		<section className="bg-[#fbfff7] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-14">
					<header>
						<div>
							<h2 className="inline-block text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
								<span className="flex items-center gap-5">
									<span>{t("industriesTitleLine1")}</span>
									<span
										className="hidden h-[3px] w-28 self-end bg-themePrimary400 sm:block md:w-36"
										aria-hidden="true"
									/>
								</span>
								<span className="mt-3 block">{t("industriesTitleLine2")}</span>
							</h2>
						</div>
					</header>

					<div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
						{INDUSTRIES.map((industry) => (
							<Link
								key={industry.keyPrefix}
								href={industry.href}
								className="group flex min-h-[120px] flex-col justify-between rounded-xl bg-[#ececec] p-2 transition-colors duration-200 hover:bg-themePrimary400 focus-visible:bg-themePrimary400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-themePrimary400 focus-visible:ring-offset-2"
							>
								<div className="relative h-16 w-16 overflow-hidden rounded-full bg-white sm:h-20 sm:w-20">
									<Image
										src={industry.image}
										alt={t(`${industry.keyPrefix}ImageAlt`)}
										fill
										className="object-cover"
										sizes="80px"
									/>
								</div>
								<h3 className="mt-5 text-right text-base font-bold text-black transition-colors duration-200 group-hover:text-white group-focus-visible:text-white sm:text-lg">
									{t(`${industry.keyPrefix}Title`)}
								</h3>
							</Link>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
